<template>
  <div class="with-bg stats app-container">
    <!-- <div class="page-title">
      <h2>{{ $t('general.users') }}</h2>
    </div>
    <div class="filter-container">
      <el-row>
        <el-col :span="8">
          <router-link :to="{path:'/administration/users', query:{type: 'Admin'}}">
            <vs-card class="default-card">
              <template #title>
                <h3>{{ $t('general.admins') }}</h3>
              </template>
              <template #text>
                <h2><count-to :start-val="0" :end-val="adminsCount" :duration="3000" class="card-panel-num" /></h2>
              </template>
            </vs-card>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link :to="{path:'/administration/users', query:{type: 'Guest'}}">
              <vs-card class="default-card">
                <template #title>
                          <h3>{{ $t('general.guest') }}</h3>
                        </template>
                <template #text>
                          <h2><count-to :start-val="0" :end-val="guestCount" :duration="3000" class="card-panel-num" /></h2>
                        </template>
              </vs-card>
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link :to="{path:'/administration/users', query:{type: 'Editor'}}">
              <vs-card class="secondary-card">
                <template #title>
                          <h3>{{ $t('general.editors') }}</h3>
                        </template>
                <template #text>
                          <h2><count-to :start-val="0" :end-val="editorsCount" :duration="3000" class="card-panel-num" /></h2>
                        </template>
              </vs-card>
            </router-link>
          </el-col>
        </el-row>
      </div> -->

    <div class="dashboard-editor-container">
      <div class="page-title">
        <h3>{{ $t('dashboard.title') }}</h3>
      </div>
      <panel-group />

      <el-row>
        <div class="chart-title">
          <h5>{{ $t('dashboard.barChartTitle') }}</h5>
        </div>
        <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:20px;">
          <bar-chart />
        </el-row>
      </el-row>

      <el-row :gutter="8">
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
          :xl="{ span: 12 }"
          style="padding-right:8px;margin-bottom:-10px;"
        >
          <div class="chart-title">
            <h5>{{ $t('dashboard.pieChartTitle') }}</h5>
          </div>
          <div class="chart-wrapper">
            <pie-chart />
          </div>
        </el-col>
        <el-col
          :xs="{ span: 24 }"
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
          :xl="{ span: 12 }"
          style="margin-bottom:-10px;"
        >
          <div class="chart-title">
            <h5>{{ $t('dashboard.boxCardTitle') }}</h5>
          </div>
          <div class="chart-wrapper">
            <box-card />
          </div>
        </el-col>
      </el-row>

      <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:20px;">
        <div class="chart-title">
          <h5>{{ $t('dashboard.lineChartTitle') }}</h5>
        </div>
        <el-row :gutter="8">
          <el-col
            :sm="{ span: 24 }"
            :md="{ span: 12 }"
            :lg="{ span: 12 }"
          >
            <div v-show="showYears">
              <label for="year-filter" class="filter-label">{{ $t("dashboard.years") }}:</label>
              <el-select
                id="year-filter"
                v-model="selectedYear"
                class="filter-item"
                filterable
                clearable
                :placeholder="$t('dashboard.selectYear')"
                @change="handleFilterYear"
              >
                <el-option
                  v-for="year in availableYears"
                  :key="year"
                  :label="year"
                  :value="year"
                />
              </el-select>
            </div>
          </el-col>
          <el-col
            :sm="{ span: 24 }"
            :md="{ span: 12 }"
            :lg="{ span: 12 }"
          >
            <!-- Filtre par espèce -->
            <div v-show="showSpecies">
              <label for="species-filter" class="filter-label">{{ $t("specie.species") }}:</label>
              <el-select id="species-filter" v-model="selectedSpecie" :placeholder="$t('dashboard.selectSpecie')" @change="handleFilterSpecie">
                <el-option
                  v-for="specie in speciesList"
                  :key="specie.id"
                  :label="specie.name"
                  :value="specie.id"
                />
              </el-select>
            </div>
          </el-col>
        </el-row>

        <line-chart :selected-year="selectedYear" :selected-specie="selectedSpecie" />
      </el-row>

      <el-row :gutter="24" style="background:#fff;margin-bottom:-32px; padding:16px 16px 0;">
        <div class="chart-title" style="margin-left: -10px;margin-right: -10px;">
          <h5>{{ $t('dashboard.mapTitle') }}</h5>
        </div>
        <Map />
      </el-row>
    </div>
  </div>
</template>

<script>
import PanelGroup from './components/PanelGroup';
import LineChart from './components/LineChart';
/* import RaddarChart from './components/RaddarChart';*/
import PieChart from './components/PieChart';
import BarChart from './components/BarChart';
// import TransactionTable from './components/TransactionTable';
// import TodoList from './components/TodoList';
import BoxCard from './components/BoxCard';
import Resource from '@/api/resource';
import RoleResource from '@/api/role';
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles

import Map from './components/Map';
const subscriptionResource = new Resource('subscriptions');
const roleResource = new RoleResource();

const dashboardResource = new Resource('dashboard');
const speciesResource = new Resource('species');

const lineChartData = {
  newVisitis: {
    expectedData: [100, 120, 161, 134, 105, 160, 165],
    actualData: [120, 82, 91, 154, 162, 140, 145],
  },
  messages: {
    expectedData: [200, 192, 120, 144, 160, 130, 140],
    actualData: [180, 160, 151, 106, 145, 150, 130],
  },
  purchases: {
    expectedData: [80, 100, 121, 104, 105, 90, 100],
    actualData: [120, 90, 100, 138, 142, 130, 130],
  },
  shoppings: {
    expectedData: [130, 140, 141, 142, 145, 150, 160],
    actualData: [120, 82, 91, 154, 162, 140, 130],
  },
};
export default {
  name: 'DashBoard',
  components: {
    PanelGroup,
    LineChart,
    /* RaddarChart,*/
    PieChart,
    BarChart,
    //  TransactionTable,
    //  TodoList,
    BoxCard,
    Map,
  },
  data() {
    return {
      adminsCount: 0,
      guestCount: 0,
      editorsCount: 0,
      list: null,
      total: 0,
      loading: true,
      query: {
        page: 1,
        limit: 15,
        keyword: '',
        role: '',
        year: null,
        specie_id: null, // Nouveau paramètre pour filtrer par espèce
      },
      roles: [],
      stats: {
        donors: 0,
        paired_exchange: 0,
        recipients: 0,
      },
      lineChartData: lineChartData.newVisitis,
      showYears: false,
      availableYears: [],
      selectedYear: null,

      selectedSpecie: null, // Nouvelle propriété pour l'espèce sélectionnée
      speciesList: [],
      showSpecies: false,
    };
  },
  created() {
    this.getRoles();
    this.getAvailableYears();
    this.fetchSpeciesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array) {
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },

    async getSubscriptionsStats(subUrl) {
      this.loading = true;
      const { data } = await subscriptionResource.sublist('/' + subUrl);
      this.stats = data;
      this.loading = false;
    },

    async getRoles() {
      this.loading = true;
      const { data } = await roleResource.list(this.query);
      this.roles = data;
      this.nonAdminRoles = [];
      this.roles.forEach(role => {
        if (role.name.toLowerCase() !== 'admin') {
          this.nonAdminRoles.push(role);
        }
      });
      this.loading = false;
      this.setSta();
    },

    getRoleUserCount(roleName) {
      const found = this.roles.find(role => role.name === roleName);
      if (found) {
        return parseInt(found.userscount);
      } else {
        return 0;
      }
    },

    setSta() {
      this.adminsCount = this.getRoleUserCount('Admin');
      this.guestCount = this.getRoleUserCount('Guest');
      this.editorsCount = this.getRoleUserCount('Editor');
    },

    handleSetLineChartData(type) {
      this.lineChartData = lineChartData[type];
    },

    async getAvailableYears() {
      const result = await dashboardResource.sublist('/available-years');
      this.availableYears = result.data;
      this.showYears = this.availableYears.length > 0;
    },
    async fetchSpeciesList() {
      try {
        const result = await speciesResource.list(); // Remplacez par l'endpoint approprié
        this.speciesList = result.data;
        this.showSpecies = result.data.length > 0;
      } catch (error) {
        console.error('Erreur lors du chargement des espèces:', error);
      }
    },
    /* handleFilterYear(year) {
      this.chart.clear();
      this.chartData = {
        diseaseLabels: [],
        stats: {},
      };
      this.initChart();
      this.showYears = false;
    }, */
    // Méthode pour filtrer par année
    handleFilterYear(year) {
      this.query.year = year;
      this.reloadChart();
      this.showYears = false;
    },

    // Méthode pour filtrer par espèce
    handleFilterSpecie(specieId) {
      this.query.specie_id = specieId;
      // this.reloadChart();
      this.showSpecies = true;
    },
    // Méthode pour recharger le graphique avec les nouveaux filtres
    /* async reloadChart() {
      this.chart.clear();
      this.chartData = {
        diseaseLabels: [],
        stats: {},
      };
      await this.initChart();
    }, */
  },
};
</script>

<style lang="scss" scoped>
.page-title {
    margin-top: -15px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}

.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}

.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  .block {
    float: left;
    min-width: 250px;
  }

  .clear-left {
    clear: left;
  }
}

.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

@media (max-width:1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}

// Carte
.mapboxgl-popup {
    max-width: 400px;
    font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    z-index: 10 !important;
}

.dashboard-editor-container {
    padding: 32px;
    background-color: rgb(240, 242, 245);

    .chart-wrapper {
        background: #fff;
        padding: 16px 16px 0;
        margin-bottom: 32px;
    }
}

.basemap {
    height: 400px;
}

#mapContainer {
    height: 100%;
    width: 100%;
}

.mapboxgl-canvas {
    width: 70vh !important;
    height: auto !important;
}

.btn-control {
    font: bold 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
    background-color: #3386c0;
    color: #fff;
    position: absolute;
    top: 20px;
    left: 50%;
    z-index: 1;
    border: none;
    width: 200px;
    margin-left: -100px;
    display: block;
    cursor: pointer;
    padding: 10px 20px;
    border-radius: 3px;
}

.btn-control-simple {
    background-color: #3386c0;
    color: #fff;
    z-index: 1;
    border: none;
    cursor: pointer;
    height: 40px;
    border-radius: 3px;
}

.btn-control:hover {
    background-color: #4ea0da;
}

.mapboxgl-popup.info-popup {
  z-index: 5 !important; /* Pour le popup de région */
}
</style>
